import { CommitmentStatusView } from './commitment-status-view.model';
import { CommitmentSummaryStatusView } from './commitment-summary-status-view';
import { CommitmentSummaryView } from './commitment-summary-view.model';
import {
    StatusViewType,
    StatusViewTypeColorMap,
    StatusViewTypeLabelMap,
} from './status-view-type.model';

export function commitmentSummaryViewToStatusViewTransformer(
    item: CommitmentSummaryView,
): CommitmentStatusView {
    let type = StatusViewType.WORKING;
    if (item.statusId === CommitmentSummaryStatusView.CLOSED) {
        type = StatusViewType.REVIEWING;
    }
    if (item.beingDisputed) {
        type = StatusViewType.BEING_DISPUTED;
    }
    return {
        show: false,
        type,
        label: StatusViewTypeLabelMap[type],
        color: StatusViewTypeColorMap[type],
    };
}

// for highlight commitment first time from oa
export function commitmentToStatusViewTransformer(
    item: CommitmentSummaryView,
): CommitmentStatusView {
    const type = StatusViewType.HIGHLIGHTED;

    return {
        show: false,
        type,
        color: StatusViewTypeColorMap[type],
    };
}
